import React from 'react';

const Maintenance = () => {
  return (
    <div style={{ textAlign: 'center', padding: '100px' }}>
      <h1>Hệ thống đang bảo trì</h1>
      <p>Chúng tôi đang nâng cấp ứng dụng để mang lại trải nghiệm tốt hơn. Vui lòng quay lại sau ít phút!</p>
    </div>
  );
};

export default Maintenance;